<template>
  <div>
    <zj-layout-container
      v-loading="loading"
      element-loading-text="加载中..."
    >
      <zj-layout-header>
        <div class="listtitle">预警配置</div>
        <el-form
          class="zj-search-form"
          ref="queryForm"
          :model="queryParams"
          :label-width="labelWidth"
        >
            <el-form-item label="预警源" prop="warnBusiness">
                <el-select v-model="queryParams.warnBusiness" filterable placeholder="请选择预警源">
                    <el-option
                        v-for="item in dict.type.warn_config_business"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                    />
                </el-select>
            </el-form-item>

            <el-form-item label="状态" prop="enableStatus">
                <el-select v-model="queryParams.enableStatus" placeholder="状态">
                    <el-option
                        v-for="item in dict.type.integrated_status"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                    />
                </el-select>
            </el-form-item>

            <el-form-item label class="right">
                <el-button @click="onSearch">查 询</el-button>
                <el-button @click="onCancel">清 理</el-button>
                <el-button @click="onAdd">新 增</el-button>
            </el-form-item>
        </el-form>
        <el-divider></el-divider>
      </zj-layout-header>
      <zj-layout-main>
        <div class="zj-layout-main-content bgcolor scrollable">
          <div class="zj-table-container">
            <el-table :data="warnConfigList" border style="width: 100%" fixed>
              <el-table-column type="index" label="序号" width="80" align="center"></el-table-column>
              <el-table-column prop="warnBusinessTranslated" label="预警源">
                <template slot-scope="scope">
                  <span>{{ scope.row.warnPoint ? scope.row.warnBusinessTranslated + '-' + scope.row.warnPointValue :  scope.row.warnBusinessTranslated }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="popupFlagTranslated" label="是否有弹框提示"></el-table-column>
              <el-table-column prop="enableStatusTranslated" label="状态"></el-table-column>
              <el-table-column label="操作" width="160" align="center">
                <template slot-scope="scope">
                  <template>
                    <el-button type="text" size="small">
                        <span v-if="scope.row.enableStatus == '1'" @click="statusClose(scope.row)">关闭</span>
                        <span v-if="scope.row.enableStatus == '2'" @click="statusOpen(scope.row)">启用</span>
                    </el-button >
                    <el-button
                      @click="queryDetail(scope.row)"
                      type="text"
                      size="small"
                      >查看</el-button
                    >
                    <el-button
                      @click="editDetail(scope.row)"
                      type="text"
                      size="small"
                      >编辑</el-button
                    >
                    <el-button
                      @click="deleteClick(scope.row)"
                      type="text"
                      size="small"
                      >删除</el-button
                    >
                  </template>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </zj-layout-main>
      <zj-layout-footer>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="queryParams.pageNum"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="queryParams.pageSize"  
          layout="total, sizes, prev, pager, next, jumper"
          background
          :total="total"
        ></el-pagination>
      </zj-layout-footer>
    </zj-layout-container>
  </div>
</template>

<script>
import { listWarnConfig, delWarnConfig, updateWarnConfig } from '@/api/src/warnConfig';
import { listEquipmentAreaTree, listEquipmentAreaTreePassengerFlow } from "@/api/src/equipmentArea";

export default {
  name: "WarnConfigView",
  controller: "UI",
  action: "WarnConfigView",
  dicts: [
    'warn_config_business',
    'integrated_status'
  ],
  data() {
    return {
      // 遮罩层
      loading: false,
      // 总条数
      total: 0,
      // 查询参数
      queryParams: {
          warnBusiness: null,
          enableStatus: null,
          pageNum: 1,
          pageSize: 10
      },
      // 表格数据
      warnConfigList: [],
      warnPointList: [],
      warnPointListPassengerFlow: []
    };
  },
  created: function() {
    this.getAreaTree();
    this.logInfo.ActionName = "预警配置查询";
    this.logInfo.LogMessage = "预警配置查询";
    this.logInfo.ModuleName = "预警系统";
    this.logInfo.PageName = "预警配置列表页";
    this.addOperationLog();
  },
  methods: {
    // 查询区域树-除了客流密度
    getAreaTree(){
      listEquipmentAreaTree().then(response =>{
        response.data.forEach(item => {
          if (item.children) {
            item.children.forEach(child => {
              response.data.push(child);
            }) 
          }
        })
        this.warnPointList = response.data;
        this.getAreaTreePassengerFlow();
      });
    },
    // 查询区域树-客流密度
    getAreaTreePassengerFlow(){
      listEquipmentAreaTreePassengerFlow({
        groupId: 4
      }).then(response =>{
        response.data.densityAllGroupInfoDtoList.forEach(item => {
          this.warnPointList.push({id: item.groupId, label: item.groupName})
        });
        this.getList();
      });
    },
    // 查询
    getList() {
      this.loading = true;
      if(global.$config.app.project=="loufanwenlv"){
        this.queryParams.systemCode = "travel";
      }
      listWarnConfig(this.queryParams).then(response =>{
        response.rows.forEach(item =>{
            this.warnPointList.forEach(child => {
              if (child.id == item.warnPoint) {
                item.warnPointValue = child.label;
              }
            })
        })
        this.warnConfigList = response.rows;
        this.total = response.total;
        this.loading = false;
      });
    },
    // 点击查询按钮
    onSearch() {
      this.queryParams.pageNum = 1;
      this.getList();
    },
    // 点击清理按钮
    onCancel() {
      this.resetForm("queryForm");
      this.onSearch();
    },
    // 点击新增按钮
    onAdd() {
      this.$router.push({
        path: "/plugin/Warn/UI/WarnConfigInfo",
        query: { type: "add" },
      });
    },
    // 行关闭
    statusClose(row){
      let form = row;
      this.$confirm('确定关闭该预警源?', "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(function() {
        form.enableStatus = '2';
        return updateWarnConfig(form);
      }).then(() => {
        this.$message({type: "success", message: '关闭成功!'});
        this.logInfo.ActionName = "预警源关闭";
        this.logInfo.LogMessage = "预警源关闭成功";
        this.logInfo.ModuleName = "预警系统";
        this.logInfo.PageName = "预警配置列表页";
        this.addOperationLog();
        this.getList();
      }).catch(() => {});
    },
    // 行启用
    statusOpen(row){
      let form = row;
      this.$confirm('确定启用该预警源?', "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(function() {
        form.enableStatus = '1';
        return updateWarnConfig(form);
      }).then(() => {
        this.$message({type: "success", message: '启用成功!'});
        this.logInfo.ActionName = "预警源启用";
        this.logInfo.LogMessage = "预警源启用成功";
        this.logInfo.ModuleName = "预警系统";
        this.logInfo.PageName = "预警配置列表页";
        this.addOperationLog();
        this.getList();
      }).catch(() => {});
    },
    // 行查看
    queryDetail(row) {
      this.$router.push({
        path: "/plugin/Warn/ui/WarnConfigInfo",
        query: { id: row.id, type: "query" },
      });
    },
    // 行编辑
    editDetail(row) {
      this.$router.push({
        path: "/plugin/Warn/ui/WarnConfigInfo",
        query: { id: row.id, type: "edit" },
      });
    },
    // 行删除
    deleteClick(row) {
      this.$confirm("此操作将永久删除该行数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(function() {
        return delWarnConfig(row.id);
      }).then(() => {
        this.$message({type: "success", message: "删除成功!"});
        this.logInfo.ActionName = "预警配置删除";
        this.logInfo.LogMessage = "预警配置删除成功";
        this.logInfo.ModuleName = "预警系统";
        this.logInfo.PageName = "预警配置列表页";
        this.addOperationLog();
        this.getList();
      }).catch(() => {});
    },
    // 点击每页显示的条数
    handleSizeChange(val){
      this.queryParams.pageSize = val;
      this.getList();
    },
    // 点击切换到某页
    handleCurrentChange(val){
      this.queryParams.pageNum = val;
      this.getList();
    }
  },
};
</script>
